module.exports = __webpack_public_path__ + "static/media/generatingCodes.ec065776.png";